// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"e6efd317","126":"3e31dce7","187":"d3c45f3c","401":"d3c45f3c","485":"77468d55","619":"afa1332c","800":"d3c45f3c"}[chunkId] + ".css";
};